import { LabelColor } from '@/components/core/label';

/**
 * Maps status values to consistent label colors across the application
 * This ensures that status labels in filter results match those in table rows
 */
export const getStatusColor = (status: string): LabelColor => {
  switch (status) {
    case 'active':
      return 'success';
    case 'pending':
      return 'info';
    case 'suspended':
      return 'warning';
    case 'cancelled':
    case 'deleted':
      return 'error';
    default:
      return 'default';
  }
};

/**
 * Maps subscription status values to consistent label colors
 */
export const getSubscriptionStatusColor = (status: string): LabelColor => getStatusColor(status); // Same mapping for now

/**
 * Maps contact status values to consistent label colors
 */
export const getContactStatusColor = (status: string): LabelColor => getStatusColor(status); // Same mapping for now

/**
 * Maps organization status values to consistent label colors
 */
export const getOrganizationStatusColor = (status: string): LabelColor => getStatusColor(status); // Same mapping for now

/**
 * Maps order status values to consistent label colors
 */
export const getOrderStatusColor = (status: string): LabelColor => {
  switch (status) {
    case 'created':
      return 'default';
    case 'pending_approval':
    case 'pendingApproval':
      return 'info';
    case 'pending_provision':
    case 'pendingProvision':
    case 'provisioning':
      return 'warning';
    case 'failed_provision':
    case 'failedProvision':
    case 'rejected':
    case 'cancelled':
      return 'error';
    case 'completed':
      return 'success';
    default:
      return 'default';
  }
};
